// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 884 ? "admin" : chunkId) + "." + {"656":"a7e68958","884":"ac92fd94"}[chunkId] + ".js";
};